'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
exports['default'] = ExceptionConfig;

function ExceptionConfig($provide) {
    /**
     * Fixes for source maps
     * @see https://github.com/angular/angular.js/issues/5217#issuecomment-50993513
     */
    $provide.decorator('$exceptionHandler', function ($delegate) {
        return function (exception, cause) {
            // switch context
            setTimeout(function () {
                throw exception;
            });

            //$delegate(exception, cause);
        };
    });
}

ExceptionConfig.$inject = ['$provide'];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./resources/assets/js/src/config/exception.js
 ** module id = 11
 ** module chunks = 0
 **/